import { useCardPaymentContext } from './hooks/useCardPaymentContext';

export function Payment() {
  const { steps, index } = useCardPaymentContext();

  return steps[index].element;
}
